import { Component } from 'san';
import * as _ from 'lodash';

import { IProject } from 'src/models';

import { dateFormat } from 'src/filters';
import uiService from 'src/services/ui.service';
import DatePicker from '../DatePicker/DatePicker';
import { MAX_PROJECT_ID_LEVEL } from 'src/consts';

export default class IssueProjectsList extends Component {
    static filters = {
        dateFormat,
    };

    static computed = {
        snColWidth() {
            return uiService.getSnColWidth(this.data.get('projects'));
        },
        isCheckedAll() {
            const projects = this.data.get('projects');
            const checkedProjects = _.filter(projects, { _is_checked: true });
            return checkedProjects.length > 0 && checkedProjects.length === projects.length;
        },
    };

    static components = {
      'ui-date-picker': DatePicker
    };

    constructor(options: any) {
        super(options);
    }

    initData(): {
        projects: IProject[]; // {}
        isSecretProjectEnabled: boolean;
    } {
        return {
            projects: [],
            isSecretProjectEnabled: false,
        };
    }

    inited() {}

    toggleCheckProject(project: IProject) {
        project = _.cloneDeep(project);
        project._is_checked = !project._is_checked;
        this.fire('change-project', project);
    }

    toggleCheckAll() {
        const isCheckedAll = !this.data.get('isCheckedAll');
        this.fire('toggle-check-all', isCheckedAll);
    }

    toggleIsNeedReceipt(project: IProject) {
      project = _.cloneDeep(project);
      project._is_need_receipt = !project._is_need_receipt;
      this.fire('change-project', project);
    }

    toggleIsSecret(project: IProject) {
      project = _.cloneDeep(project);
      project._is_secret = 'true' === project._is_secret ? 'false' : 'true'
      this.fire('change-project', project);
    }

    toUpdateProject(project: IProject) {
        this.fire('to-update-project', project);
    }

    // 完成时间变更
    onEndOnChange(endOn: string, project: IProject) {
      project = _.cloneDeep(project);
      project._end_on = endOn;
      this.fire('change-project', project);
    }

    // 追加子项目
    toAddSubProject(project: IProject) {
        this.fire('to-add-sub-project', project);
    }

    // 复制
    toCopyProject(project: IProject) {
        this.fire('to-copy-project', project);
    }

    // 最多只能创建5层项目
    getProjectIsCanAddSync(project: IProject) {
        return project.id_level < MAX_PROJECT_ID_LEVEL;
    }
}
